import axios from 'axios'
import { CommonProcedureResponse } from '@/api/services/common/procedure/common-procedure.dto'

class CommonProcedureService {
    async getProcedures(): Promise<CommonProcedureResponse[]> {
        const response = await axios.get<CommonProcedureResponse[]>(`/procedure/`)
        return response.data
    }
}

export const commonProcedureService = new CommonProcedureService()
